import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=7297ca5b&"
import script from "./Model.vue?vue&type=script&lang=ts&"
export * from "./Model.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports